import Box from '@mui/material/Box';
import { audienceLocation } from '../../constants';
import { DemographicsSection } from '../expandableSections/demographics/DemographicsSection';
import { LocationSection } from '../expandableSections/location/LocationSection';
import { LookalikeSegmentsSection } from '../expandableSections/lookalike/LookalikeSegmentsSection';
import { SegmentsSection } from '../expandableSections/segments/SegmentsSection';
import type { GroupContentBaseProps } from './groupContentTypes';

export const GroupContentLegacy = ({
  field,
  groupFieldName,
  groupName,
  index,
  isEdit,
  isEmptyGroup,
  listType,
  setDrawerState,
  update,
  isExpanded,
  toggle,
  selectedLocationSegment,
  handleSelectedLocationSegmentChange,
  isIdentityGraphMatchType,
  shouldDisplayLookalikeSection,
}: GroupContentBaseProps) => (
  <Box data-test="includes-segment-subgroup">
    <SegmentsSection
      isEdit={isEdit}
      field={field}
      isEmptyGroup={isEmptyGroup}
      groupName={groupName}
      groupFieldName={groupFieldName}
      listType={listType}
      setDrawerState={setDrawerState}
      update={update}
      index={index}
      isExpanded={isExpanded(`${field.uuid}_segments`)}
      onToggleExpand={toggle(`${field.uuid}_segments`)}
    />

    {isIdentityGraphMatchType && (
      <>
        {shouldDisplayLookalikeSection && (
          <LookalikeSegmentsSection
            isEdit={isEdit}
            field={field}
            isEmptyGroup={isEmptyGroup}
            groupName={groupName}
            groupFieldName={groupFieldName}
            listType={listType}
            setDrawerState={setDrawerState}
            update={update}
            index={index}
            isExpanded={isExpanded(`${field.uuid}_lookalike`)}
            onToggleExpand={toggle(`${field.uuid}_lookalike`)}
          />
        )}

        <DemographicsSection
          isEdit={isEdit}
          groupFieldName={groupFieldName}
          listType={listType}
          update={update}
          index={index}
          isExpanded={isExpanded(`${field.uuid}_demographics`)}
          onToggleExpand={toggle(`${field.uuid}_demographics`)}
        />

        <LocationSection
          isEdit={isEdit}
          groupFieldName={groupFieldName}
          listType={listType}
          update={update}
          index={index}
          isExpanded={isExpanded(`${field.uuid}_location`)}
          onToggleExpand={toggle(`${field.uuid}_location`)}
          selectedLocationSegment={selectedLocationSegment ?? audienceLocation.Any}
          setSelectedLocationSegment={segment => handleSelectedLocationSegmentChange(segment, index)}
        />
      </>
    )}
  </Box>
);
